module.exports = __webpack_public_path__ + "img/reflective-reader.f9588866.png";